// import Vue from 'vue';
 import Vuex from 'vuex';

// Vue.use(Vuex);


 
export default new Vuex.Store({
  state: {
    navigationState:'A'
  },
  mutations: {
    updateNavigationState(state, newState) {
      state.navigationState = newState;
    },
  }
});